<template>
  <div class="">
    <div class="" v-if="!loading && hasFiles">
      <alert :message="i18n.help" class="px-2 py-1 text-sm"></alert>
      <bridge-file
        v-for="file in files"
        :key="file.id"
        :data="file"
        @re-use="reuse($event, file)"
        :i18n="i18n"
      >
      </bridge-file>
    </div>
    <div class="" v-if="!loading && !hasFiles">
      <alert :message="i18n.empty" class="px-2 py-1 text-sm"></alert>
    </div>
    <div class="min-h-32 flex justify-center items-center" v-if="loading">
      <loading></loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { captureException } from "@sentry/browser";

import BridgeFile from "./BridgeFile";

export default {
  props: ["i18n", "project"],
  components: { BridgeFile },
  data() {
    return {
      files: [],
      loading: true,
    };
  },
  methods: {
    getFiles() {
      axios
        .get(this.bridgeUrl)
        .then(({ data }) => {
          this.files = data.map((f) => {
            f.status = "idle";
            f.progress = 0;
            f.error = undefined;
            return f;
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          //console.log(response);
        });
    },

    reuse(payload, file) {
      if (file.status !== "idle" && file.status !== "error") {
        return;
      }

      file.status = "working";
      file.error = undefined;

      axios
        .get(file.url.replace("...filename...", payload.filename), {
          onDownloadProgress: (progressEvent) => {
            let response = progressEvent.target.responseText.split(/\r?\n/);
            if (response.length >= 2) {
              let percent = parseInt(response[response.length - 2]);
              if (percent <= 100) {
                file.progress = percent;
              }
            }
          },
          transformRequest: [
            function (data, headers) {
              delete headers.common;
              return data;
            },
          ],
        })
        .then((response) => {
          //console.log('>>>> response status : ' + response.status);
          if (response.status === 200) {
            file.status = "completed";
            file.progress = 100;
            this.$store.commit("dashboard/updateProjectStatus", {
              id: this.projectId,
              status: "uploaded",
            });
          } else {
            captureException(response.data.err);
            file.status = "error";
            file.error = this.errorText(response.data.err);
          }
        })
        .catch((error) => {
          if (error.response) {
            captureException(error.response.data.err);
            file.status = "error";
            file.error = this.errorText(error.response.data.err);
          } else {
            captureException(error);
            file.status = "error";
            file.error = "Unkown exception (see console)";
            //throw error;
          }
        });
    },
    errorText(err) {
      let error = err.trim();

      if (Object.prototype.hasOwnProperty.call(this.i18n.errors, error)) {
        return this.i18n.errors[error];
      }

      return error;
    },
  },
  computed: {
    bridgeUrl() {
      if (this.$route.query.exp_endpoint) {
        return this.project.routes.upload.bridge_exp;
      }
      return this.project.routes.upload.bridge;
    },
    hasFiles() {
      return this.files.length > 0;
    },
    projectId() {
      return this.project.id;
    },
  },
  mounted() {
    this.getFiles();
  },
};
</script>
